import './style.scss';

// Slider - Library import example
import { tns } from "tiny-slider"
// Lightbox
import GLightbox from "glightbox";

// Select fields 
import TomSelect from 'tom-select/dist/js/tom-select.base.js';

// GSAP
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin( ScrollTrigger );

// Google Map
import { Loader } from "@googlemaps/js-api-loader";

let map;

document.addEventListener( 'DOMContentLoaded', () => {
	// Lazy load fade in
	document.querySelectorAll( 'img[loading="lazy"]' ).forEach( ( img ) => {
		if( img.complete === true ) {
			img.classList.add( 'has-loaded' );
		}
		img.addEventListener( "load", ( e ) => {
			e.target.classList.add( 'has-loaded' );
		} );
	} );

	// Login toggle 
	document.querySelectorAll( '.wp-block-loginout' ).forEach( ( loginout ) => {
		loginout.addEventListener( 'click', ( e ) => {
			if( e.target.classList.contains( 'wp-block-loginout' ) ) {
				loginout.classList.toggle( 'is-active' );
			}
		} );
	} );

	// Copyright year
	document.querySelectorAll( '.copyright' ).forEach( ( copy ) => {
		const d = new Date();
		copy.innerHTML = copy.innerHTML.replace( '{{YEAR}}', d.getFullYear() );
	} );

	// Home parallax
	let mm = gsap.matchMedia();

	mm.add("(min-width: 782px)", () => {
		if( document.querySelector( ".wp-block-cover.is-style-parallax .wp-block-cover__image-background" ) ) {
			parallaxCover();
		}
	} );

	// iOS window height work around  
	window.addEventListener( 'resize', () => {
		bones_theme_window_height();
	} );
	bones_theme_window_height();

	// Tom Select
	if( document.querySelector( '.frm_forms select' ) ) {
		new TomSelect( ".frm_forms select" , {
			create: true,
			maxItems: 1
		} );
	}

	// Cards loaded
	document.querySelectorAll( '.map-cards > li > ul' ).forEach( ( slider, i ) => {
		slider.addEventListener( 'cards-loaded', ( e ) => {
			if( e.target.style.display != "none" ) {
				// Slider
				tns( {
					container: e.target,
					mode: 'carousel',
					items: 1,
					autoplay: false,
					autoplayButtonOutput: false,
					nav: false,
					lazyload: true,
					controlsText: ["", ""],
					gutter: 8,
					responsive: {
						640: {
							items: 2
						},
						768: {
							items: 3
						},
						900: {
							items: 4
						}
					}
				} );
				
				// Maps center
				// document
				e.target.querySelectorAll( '.card' ).forEach( ( card ) => { 
					card.addEventListener( 'mouseover', ( e ) => { 
						const cardSelected = ( e.target.classList.contains('card') ) ? e.target : e.target.closest( '.card' );
						const cLat = parseFloat( cardSelected.dataset['lat'] );
						const cLng = parseFloat( cardSelected.dataset['lng'] );
						const newCenter = { lat: cLat, lng: cLng };
						if( map.getCenter() != newCenter ) {
							map.setZoom( 19 );
							map.panTo( newCenter );
							// console.log( newCenter );
						}
					} );
				} );
			}
		} );
	} );

	// Map buttons
	document.querySelectorAll( '.map-buttons a.wp-block-button__link' ).forEach( ( button, i ) => { 
		button.addEventListener( 'click', ( e ) => {
			const type = e.target.dataset['type'];
			const button = e.target.parentElement;
			// Check if not already selected 
			if( !button.classList.contains( 'is-active' ) ) {
				const prevType = document.querySelector( '.map-buttons .is-active .wp-block-button__link' )?.dataset['type'];
				document.querySelector( '.map-buttons .is-active' )?.classList.remove( 'is-active' );
				document.querySelector( '.map-cards .is-active' )?.classList.remove( 'is-active' );

				button.classList.add( 'is-active' );
				document.querySelector( '.map-cards .' + type )?.classList.add( 'is-active' );

				// Update pins
				if( pins[ prevType ] !== undefined ) {
					pins[ prevType ].forEach( ( pin ) => { 
						pin.setMap( null );
					} );
				}
				if( pins[ type ] !== undefined ) {
					pins[ type ].forEach( ( pin ) => { 
						pin.setMap( map );
					} );
				}
			}
		} );
	} );

	// Lightbox
	document.querySelectorAll( '.wp-block-image a[href*=".jpg"], .wp-block-image a[href*=".png"]' ).forEach( ( link, i ) => {
		link.classList.add( 'glightbox' );
	} );

	// Init lightbox
	GLightbox( {
		touchNavigation: true,
		loop: true,
		autoplayVideos: true
	} );

	// View Gallery button
	document.querySelector( 'a[href*="#view-gallery"]' )?.addEventListener( 'click', () => {
		if( document.querySelectorAll( '.wp-block-image a[href*=".jpg"], .wp-block-image a[href*=".png"]' ).length ) {
			document.querySelectorAll( '.wp-block-image a[href*=".jpg"], .wp-block-image a[href*=".png"]' )[0].click();
		}
	} );

	// Empty Hash Links
	document.querySelectorAll( 'nav a[href="#"]' ).forEach( ( item ) => { 
		item.addEventListener( 'click', ( e ) => {
			e.preventDefault();
		} );
	} );	

	// Leasing and other scrolling links - including '#' but not ending in '#'
	document.querySelectorAll( 'nav a[href*="#"]:not([href$="#"])' ).forEach( ( link ) => {
		link.addEventListener( 'click', ( e ) => {
			// Check if page matches current
			const href = e.target.closest( 'a' ).href.split( "#" );
			const target = window.location.origin + window.location.pathname;
			if( href[0] == target ) { // Same page
				e.preventDefault();
				const block = document.querySelector( '#' + href[1] );
				if( block ) {
					const top = block.offsetTop - document.querySelector( 'header' ).offsetHeight;
					window.scrollTo( { top: top, behavior: 'smooth' } );
				}
			}
		} );
	} );
	
	if( document.querySelector( '.search-trigger > a' ) ) {
		document.querySelector( '.search-trigger > a' ).addEventListener( 'click', ( e ) => {
			e.preventDefault();
			document.body.classList.toggle( 'show-search' );
		} );
	}

	// Contact map
	if( document.getElementById( "contact-map" ) ) {
		const loader = new Loader( {
			apiKey: "AIzaSyBgNg8St5B7K6V3dC5o4tocP5zlW8tux2k",
			version: "weekly",
			libraries: ["places"]
		} );
		
		const mapOptions = {
			center: {
				lat: -31.953955140600197,
				lng: 115.85640305767089
			},
			zoom: 18
		};

		
		
		loader
		.importLibrary( 'maps' )
		.then( ( { Map } ) => {
			map = new Map( document.getElementById( "contact-map" ), mapOptions );

			const icon = {
				url: document.getElementById( "contact-map" ).dataset.icon,
				scaledSize: new google.maps.Size( 66, 100 ),
				origin: new google.maps.Point( 0, 0 ),
				anchor: new google.maps.Point(35, 35)
			};
			
			const marker = new google.maps.Marker( {
				position: new google.maps.LatLng(-31.953955140600197, 115.85640305767089),
				icon: icon,
				map: map,
			});
		})
		.catch((e) => {
			// do something
		});
	}
} );

const parallaxCover = () => {
	const headerHeight = document.querySelector( "header.wp-block-template-part" ).offsetHeight;
	const offsetHeight = document.querySelector( ".wp-block-cover.is-style-parallax .wp-block-cover__image-background" ).offsetHeight;
	
	const tl = gsap.timeline( {
		scrollTrigger: {
			trigger: ".wp-block-cover.is-style-parallax",
			start: "top " + headerHeight + "px",
			end: "bottom top",
			scrub: true
		}
	} );
	
	tl.to( 
		".wp-block-cover.is-style-parallax .wp-block-cover__image-background",
		{ y: offsetHeight, ease: "none" },
		0
	)
	tl.to(
		".wp-block-cover.is-style-parallax .wp-block-cover__inner-container",
		{ y: offsetHeight / 2, ease: "none", opacity: 0 },
		0
	)
}

// iOS window height
const bones_theme_window_height = () => {
	console.log( 'bones_theme_window_height');
  document.documentElement.style.setProperty('--app--height', `${window.innerHeight}px`);

	if( document.querySelector( 'header' ) ) {
		document.documentElement.style.setProperty('--app--header--height', `${document.querySelector( 'header' ).offsetHeight}px`);
	}
}